import axios from "@/plugins/axios";
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";
import clone from "lodash/cloneDeep";
import i18n from "../../i18n";
import CryptoJS from "crypto-js";
import Vue from "vue";
import router from '@/router'

export default {
  namespaced: true,
  state: () => ({
    status: !!JSON.parse(localStorage.getItem("user")),
    company: localStorage.getItem("company") || "",
    user: JSON.parse(localStorage.getItem("user")) || {},
    token: JSON.parse(localStorage.getItem("token")) || "",
    permissions: JSON.parse(localStorage.getItem("permissions")) || [],
    isCompany: true,
    urlSE: "",
    lang: localStorage.getItem("lang") || "",
    primerlogin: localStorage.getItem("primerlogin") || null,
    activeAzure: localStorage.getItem("activeAzure") || null,
    clientIdAzure: "",
    tenantAzure: "",
    activeVisualTime: localStorage.getItem("activeVisualTime") || "NO",
    visualTimeToken: localStorage.getItem("tokenVisualTime") || "",
    activeKeycloak: "",
    clientIdKeycloak: "",
    urlKeycloak: "",
    realm: "",
  }),
  getters: {
    status: (state) => state.status,
    company: (state) => state.company,
    user: (state) => state.user,
    token: (state) => state.token,
    primerlogin: (state) => state.primerlogin,
    userAvatarName: (state) =>
      state.user && state.user.nombre && state.user.apellido
        ? state.user.nombre[0] + state.user.apellido[0]
        : "",
    permissions: (state) =>
      state.permissions.reduce(
        (old, current) => Object.assign(old, { [current.path]: current }),
        {
          menuCasos: !!state.permissions.find(
            (item) =>
              [
                "casos",
                "casos.buscar",
                "casos.supervisar",
                "casos.supervisarHistorico",
                "casos.sinAsignar",
                "casos.supervisarProcesos",
                "casos.supervisarHistoricoProcesos",
                "casos.supervisarEquipo",
                "casos.supervisarEquipoHistorico",
              ].includes(item.path) && item.listar
          ),
          tabapcaso: !!state.permissions.find(
            (item) => ["apdesdecaso"].includes(item.path) && item.listar
          ),
          menuActividadesprogramadas: !!state.permissions.find(
            (item) =>
              [
                "despachador",
                "actividadesprogramadas",
                "actividadesprogramadas.configuracion",
              ].includes(item.path) && item.listar
          ),
          menuProyectos: !!state.permissions.find(
            (item) =>
              [
                "proyectos",
                "proyectos.estadisticas",
                "proyectos.informes",
              ].includes(item.path) && item.listar
          ),
          menuLicencias: !!state.permissions.find(
            (item) => ["licencia", "company"].includes(item.path) && item.listar
          ),
          menuDashboardview: !!state.permissions.find(
            (item) =>
              ["dashboradview", "dashboradview"].includes(item.path) &&
              item.listar
          ),
          menuReportesC: !!state.permissions.find(
            (item) =>
              ["extraccion", "reportes", "configuraciondash"].includes(
                item.path
              ) && item.listar
          ),
          menuReportes: !!state.permissions.find(
            (item) =>
              ["misreportes", "reportedash"].includes(item.path) && item.listar
          ),
          menuProducto: !!state.permissions.find(
            (item) =>
              ["productos", "tipocasos", "multityping"].includes(item.path) &&
              item.listar
          ),
          menuContactos: !!state.permissions.find(
            (item) =>
              ["contactos", "cuentas"].includes(item.path) && item.listar
          ),
          menuParametro: !!state.permissions.find(
            (item) =>
              [
                "camposper",
                "slo",
                "categorias",
                "prioridades",
                "estados",
              ].includes(item.path) && item.listar
          ),
          menuAgente: !!state.permissions.find(
            (item) =>
              [
                "roles",
                "usuarios",
                "gruposkill",
                "conceptos",
                "empresas",
              ].includes(item.path) && item.listar
          ),
          menuProceso: !!state.permissions.find(
            (item) =>
              [
                "procesos",
                "chequeo",
                "chequeo.script",
                "chequeo.html",
                "sistemasexternos",
              ].includes(item.path) && item.listar
          ),
          menuConfiguracion: !!state.permissions.find(
            (item) =>
              [
                "roles",
                "estados",
                "conceptos",
                "tipocasos",
                "prioridades",
                "categorias",
                "slo",
                "productos",
                "navegacion",
                "correos",
                "sistemasexternos",
                "reportes",
                "camposper",
                "parametros",
                "respuestaspredefinidas",
              ].includes(item.path) && item.listar
          ),
          menuGestioncasillas: !!state.permissions.find(
            (item) =>
              ["parametrizacioncasoscorreos", "casillascorreos"].includes(
                item.path
              ) && item.listar
          ),
          menuLlamadas: !!state.permissions.find(
            (item) =>
              ["calls", "managmentcalls", "managmentchannel"].includes(
                item.path
              ) && item.listar
          ),
          menuSegmentacion: !!state.permissions.find(
            (item) =>
              ["segmentacion", "segmentacion.procesos"].includes(item.path) &&
              item.listar
          ),
          menuOutboundPlantillas: !!state.permissions.find(
            (item) =>
              [
                "outboundplantillasemail",
                "outboundplantillaspush",
                "outboundplantillassms",
                "outboundplantillaswhatsapp",
                "outboundplantillasaprobacion",
              ].includes(item.path) && item.listar
          ),
          menuOutboundReportes: !!state.permissions.find(
            (item) => ["outboundreportes"].includes(item.path) && item.listar
          ),
          menuOutboundConfiguracion: !!state.permissions.find(
            (item) =>
              [
                "outboundconfiguracioncanales",
                "outboundconfiguracionestados",
                "outboundconfiguracionferiados",
                "outboundconfiguracionhorarios",
                "outboundconfiguracionparametros",
                "outboundconfiguracionlinea",
                "outboundconfiguracionsublinea",
                "outboundconfiguracioncodigo",
                "outboundconfiguracionexcepciones",
              ].includes(item.path) && item.listar
          ),
          hyperpersonalizacion: !!state.permissions.find(
            (item) =>
              [
                "hpformulariohyperpersonalizacion",
                "hpadministracionhyperpersonalizacion",
                "hpaprobacionhyperpersonalizacion",
              ].includes(item.path) && item.listar
          ),
          hyperpersonalizacionCreated: !!state.permissions.find(
            (item) =>
              ["hppantallahyperpersonalizacion"].includes(item.path) &&
              item.listar
          ),
          hyperpersonalizacionConfig: !!state.permissions.find(
            (item) =>
              ["hpconfiguracionhyperpersonalizacion"].includes(item.path) &&
              item.listar
          ),
          catalogoDocumentos: !!state.permissions.find(
            (item) =>
              ["catalogodocumentos"].includes(item.path) && item.listar
          ),
          gestorDocumental: !!state.permissions.find(
            (item) =>
              ["gestordocumental"].includes(item.path) && item.listar
          ),
        }
      ),
    homePage: (state) => {
      const item = state.permissions.find((item) => item.home && item.listar);
      return { name: item ? item.path : "403" };
    },
    urlSE: (state) => state.urlSE,
    lang: (state) => state.lang,
    activeAzure: (state) => state.activeAzure,
    clientIdAzure: (state) => state.clientIdAzure,
    tenantAzure: (state) => state.tenantAzure,
    activeVisualTime: (state) => state.activeVisualTime,
    visualTimeToken: (state) => state.visualTimeToken,
    activeKeycloak: (state) => state.activeKeycloak,
    clientIdKeycloak: (state) => state.clientIdKeycloak,
    urlKeycloak: (state) => state.urlKeycloak,
    realm: (state) => state.realm,
  },
  mutations: {
    setStatus(state, value) {
      state.status = value;
    },
    setCompany(state, value) {
      state.company = value;
      if (!isEmpty(value)) {
        localStorage.setItem("company", value);
      } else {
        localStorage.removeItem("company");
      }
    },
    setIsCompany(state, value) {
      state.isCompany = value;
    },
    setUser(state, value) {
      state.user = value;
      if (!isEmpty(value)) {
        localStorage.setItem("user", JSON.stringify(value));
      } else {
        localStorage.removeItem("user");
      }
    },
    setPrimerLogin(state, value) {
      state.primerlogin = value;
      if (value !== null) {
        localStorage.setItem("primerlogin", value);
      } else {
        localStorage.removeItem("primerlogin");
      }
    },
    setToken(state, value) {
      state.token = value;
      if (!isEmpty(value)) {
        localStorage.setItem("token", JSON.stringify(value));
      } else {
        localStorage.removeItem("token");
      }
    },
    setPermissions(state, value) {
      state.permissions = value;
      if (!isEmpty(value)) {
        localStorage.setItem("permissions", JSON.stringify(value));
      } else {
        localStorage.removeItem("permissions");
      }
    },
    setUrlSE(state, value) {
      state.urlSE = value;
    },
    setLang(state, value) {
      state.lang = value;
      if (!isEmpty(value)) {
        i18n.locale = value;
        localStorage.setItem("lang", value);
      }
      // else {
      //     i18n.locale = 'en'
      //     localStorage.removeItem('lang')
      // }
    },
    setActiveAzure(state, value) {
      state.activeAzure = value;
      if (!isEmpty(value)) {
        localStorage.setItem("activeAzure", value);
      } else {
        localStorage.removeItem("activeAzure");
      }
    },
    setClientIdAzure(state, value) {
      state.clientIdAzure = value;
    },
    setTenantAzure(state, value) {
      state.tenantAzure = value;
    },
    setActiveVisualTime(state, value) {
      localStorage.setItem("activeVisualTime", value);
      state.activeVisualTime = value;
    },
    setVisualTimeToken(state, value) {
      localStorage.setItem("tokenVisualTime", value);
      state.visualTimeToken = value;
    },
    setActiveKeycloak(state, value) {
      state.activeKeycloak = value;
      if (!isEmpty(value)) {
        localStorage.setItem("activeKeycloak", value);
      } else {
        localStorage.removeItem("activeKeycloak");
      }
    },
    setClientIdKeycloak(state, value) {
      state.clientIdKeycloak = value;
    },
    setUrlKeycloak(state, value) {
      state.urlKeycloak = value;
    },
    setRealm(state, value) {
      state.realm = value;
    },
  },
  actions: {
    setTkn({ commit }, tkn) {
      commit("setCompany", "bea360");
      commit("setUser", "DMezaro");
      commit("setStatus", true);
      commit("setToken", tkn);
    },
    setProfile({ commit }, user) {
      commit("setUser", clone(user));

      return Promise.resolve();
    },
    async getPermissions({ commit, state }) {
      const params = { id: state.user.idrol };

      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.get("permisos/getby", { params });
        commit("setPermissions", response.data);
        commit("setLoading", -1, { root: true });

        return response;
      } catch (e) {
        commit("setLoading", -1, { root: true });

        return Promise.reject(e.response.data);
      }
    },
    async login({ commit, dispatch }, credentials) {
      const { user, pass, company } = credentials;

      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post("login/auth", {
          user,
          pass,
          company,
          origenlogin: "consola",
        });
        commit("setLoading", -1, { root: true });

        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }

        commit("setStatus", true);
        commit("setCompany", credentials.company);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);
        commit("setPrimerLogin", response.data.primerlogin);

        // this.$i18n.locale = response.data.usuario.language

        return response;
      } catch (e) {
        dispatch("logout");
        return Promise.reject(new Error(e));
      }
    },
    async visualtime({ commit, dispatch }, credentials) {
      const { user, pass, company } = credentials;

      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post("login/auth/visualtime", {
          user,
          pass,
          company,
          origenlogin: "consola",
        });
        commit("setLoading", -1, { root: true });

        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }

        commit("setStatus", true);
        commit("setCompany", credentials.company);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);
        commit("setPrimerLogin", response.data.primerlogin);
        commit("setVisualTimeToken", response.data.visualTimeToken);

        return response;
      } catch (error) {
        dispatch("logout");
        return Promise.reject(new Error());
      }
    },
    async checkVisualTimeToken({ commit, state }) {
      const user = state.user.user;
      const token = state.visualTimeToken;
      const company = state.company;
      try {
        const response = await axios.post("login/auth/checkvisualtimetoken", {
          user,
          token,
          company,
        });
        commit("setVisualTimeToken", response.data.token);
      } catch {
        return Promise.reject(new Error());
      }
    },
    async loginSSO({ commit, dispatch }, credentials) {
      // commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post("login/auth/sso", credentials);
        // commit('setLoading', -1, { root: true })

        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }

        commit("setStatus", true);
        commit("setCompany", credentials.company);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);

        return response;
      } catch (e) {
        dispatch("logout");
        return Promise.reject(new Error());
      }
    },

    async recovery({ commit, dispatch }, credentials) {
      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post("login/recovery", credentials);
        commit("setLoading", -1, { root: true });

        return response;
      } catch (e) {
        commit("setLoading", -1, { root: true });
        return Promise.reject(new Error());
      }
    },
    async logout({ commit }) {
      const token = localStorage.getItem("token");
      async function logoutFunction({ commit }) {
        try {
          // Envía la solicitud de cierre de sesión con el token en el encabezado
          await axios.post(
            "login/auth/logout",
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } catch (error) {
        } finally {
          // Esto se ejecutará sin importar si la solicitud tuvo éxito o falló
          commit("setStatus", false);
          commit("setUser", {});
          commit("setToken", "");
          commit("setPermissions", []);
          commit("setLoading", -1, { root: true });
          commit("setPrimerLogin", null);
          const a = "adal";
          const kc = "kc";
          const keys = Object.keys(localStorage);

          for (const i in keys) {
            const key = keys[i];
            if (key.includes(a)) {
              window.localStorage.removeItem(key);
            }
            if (key.includes("activeAzure")) {
              window.localStorage.removeItem(key);
            }
            if (key.includes(kc)) {
              window.localStorage.removeItem(key);
            }
          }
        }
      }
      if (Vue.$keycloak) {
        if (Vue.$keycloak.authenticated) {
          router.push({name:"menu"})
          try {
            await logoutFunction({ commit });
            Vue.$keycloak.logout();
            return Promise.resolve();
          } catch (e) {}
        } else {
          await logoutFunction({ commit });
          return Promise.resolve();
        }
      } else {
        await logoutFunction({ commit });
        return Promise.resolve();
      }
    },

    validatetoken({ commit, dispatch }, credentials) {
      commit("setLoading", 1, { root: true });
      try {
        const response = axios.post("logintk/authwithtoken", credentials);
        commit("setLoading", -1, { root: true });

        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }

        commit("setStatus", true);
        commit("setCompany", credentials.company);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);

        // this.$i18n.locale = response.data.usuario.language

        return response;
      } catch (e) {
        dispatch("logout");
        return Promise.reject(new Error());
      }
    },
    async externalLogin({ commit, dispatch }, credentials) {
      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post(
          "login/authwithtoken",
          credentials.token ? { token: credentials.token } : credentials
        );
        commit("setLoading", -1, { root: true });

        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }
        const dec = atob(credentials.token);
        commit("setStatus", true);
        commit("setCompany", dec.split(" ")[0]);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);

        // this.$i18n.locale = response.data.usuario.language
        if (credentials.loginSE) {
          // localStorage.setItem('loginSE', credentials.login)
          return { ...response, tokenEncode: credentials.token };
        } else {
          return response;
        }
      } catch (e) {
        dispatch("logout");
        return Promise.reject(new Error());
      }
    },
    async loginExternalSE({ commit, dispatch }, credentials) {
      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post(
          "login/authexternalsystem",
          credentials
        );
        commit("setLoading", -1, { root: true });

        return response.data;
      } catch (e) {
        // dispatch('logout')
        return Promise.reject(e);
      }
    },

    async loginSENoKeys({ commit, dispatch }, credentials) {
      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post(
          "login/authexternalsystemnokeys",
          credentials.token ? { token: credentials.token } : credentials
        );
        commit("setLoading", -1, { root: true });

        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }
        const dec = atob(credentials.token);
        // var dec= Buffer.from(credentials.token,'base64')
        commit("setStatus", true);
        commit("setCompany", dec.split(" ")[0]);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);

        // this.$i18n.locale = response.data.usuario.language
        if (credentials.loginSE) {
          // localStorage.setItem('loginSE', credentials.login)
          return { ...response, tokenEncode: credentials.token };
        } else {
          return response;
        }
      } catch (e) {
        dispatch("logout");
        return Promise.reject(new Error());
      }
    },

    async getCompanyForAzure({ commit }, credentials) {
      // para pruebas en local - comen tar antes de enviar a dev
      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post("login/auth/parametroscompany", {
          company: credentials,
        });
        commit("setLoading", -1, { root: true });
        commit("setActiveAzure", response.data[0][0].value);
        commit(
          "setActiveVisualTime",
          response.data.find(
            (parameter) => parameter?.key === "ACTIVE_VISUAL_TIME"
          ).value
        );

        if (response.data[0][0].value === "SI") {
          const llave = "oasisriveroasisr";
          const key = llave
            ? CryptoJS.enc.Utf8.parse(llave)
            : CryptoJS.enc.Utf8.parse("surveyatseucnesu");

          const dataTenant = response.data[2][0].value;
          const decryptTenat = CryptoJS.AES.decrypt(dataTenant, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
          });
          const tenantDecrypted =
            CryptoJS.enc.Utf8.stringify(decryptTenat).toString();

          const dataClientId = response.data[1][0].value;
          const decryptClientId = CryptoJS.AES.decrypt(dataClientId, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
          });
          const clientIdDecrypted =
            CryptoJS.enc.Utf8.stringify(decryptClientId).toString();

          commit("setTenantAzure", tenantDecrypted);
          commit("setClientIdAzure", clientIdDecrypted);
        }
      } catch (e) {
        return Promise.reject(e);
      }
      return Promise.response;
    },
    async loginByAzure(
      { commit, dispatch },
      [company, email, oid, sub, upn, idclient]
    ) {
      commit("setLoading", 1, { root: true });

      const llave = "oasisriveroasisr";
      const key = llave
        ? CryptoJS.enc.Utf8.parse(llave)
        : CryptoJS.enc.Utf8.parse("surveyatseucnesu");
      const oidSrc = CryptoJS.enc.Utf8.parse(JSON.stringify(oid));
      const oidEnc = CryptoJS.AES.encrypt(oidSrc, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      const subSrc = CryptoJS.enc.Utf8.parse(JSON.stringify(sub));
      const subEnc = CryptoJS.AES.encrypt(subSrc, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      const upnSrc = CryptoJS.enc.Utf8.parse(JSON.stringify(upn));
      const upnEnc = CryptoJS.AES.encrypt(upnSrc, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      const emailSrc = CryptoJS.enc.Utf8.parse(JSON.stringify(email));
      const emailEnc = CryptoJS.AES.encrypt(emailSrc, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();

      try {
        const response = await axios.post("login/auth/azure", {
          company,
          email: emailEnc,
          oid: oidEnc,
          sub: subEnc,
          upn: upnEnc,
          idclient,
          origenlogin: "consola",
        });
        commit("setLoading", -1, { root: true });
        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }
        commit("setStatus", true); // parámetros visibles en localStorage
        commit("setCompany", company);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);
        commit("setPrimerLogin", response.data.primerlogin);
        // this.$i18n.locale = response.data.usuario.language
        return response;
      } catch (e) {
        dispatch("logout");
        // return Promise.reject(new Error())
        // Se recibe el error del backend.
        return Promise.reject(e);
      }
    },
    async loginByKeycloak({ commit, dispatch }, [company, email, user, token]) {
      async function encrypt(data, secretKey) {
        const key = new TextEncoder().encode(secretKey);
        const iv = crypto.getRandomValues(new Uint8Array(12)); // Crear un IV aleatorio
        const cryptoKey = await crypto.subtle.importKey(
          "raw",
          key,
          { name: "AES-GCM" },
          false,
          ["encrypt"]
        );
        const encodedData = new TextEncoder().encode(data);
        const encryptedArrayBuffer = await crypto.subtle.encrypt(
          { name: "AES-GCM", iv },
          cryptoKey,
          encodedData
        );

        const encryptedBytes = new Uint8Array(encryptedArrayBuffer);
        const encryptedDataWithIv = new Uint8Array(
          iv.length + encryptedBytes.length
        );
        encryptedDataWithIv.set(iv);
        encryptedDataWithIv.set(encryptedBytes, iv.length);

        return btoa(String.fromCharCode.apply(null, encryptedDataWithIv));
      }
      commit("setLoading", 1, { root: true });
      const key = process.env.VUE_APP_KC;
      const emailEnc = await encrypt(email, key);
      const userEnc = await encrypt(user, key);
      try {
        const response = await axios.post("login/auth/keycloak", {
          company,
          email: emailEnc,
          user: userEnc,
          origenlogin: "consola",
          token,
        });
        commit("setLoading", -1, { root: true });
        if (isEmpty(filter(response.data.usuario))) {
          return Promise.reject(new Error());
        }
        commit("setStatus", true);
        commit("setCompany", company);
        commit("setUser", response.data.usuario);
        commit("setToken", response.data.token);
        commit("setPermissions", response.data.permisos);
        commit("setPrimerLogin", response.data.primerlogin);
        return response;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getCompanyForKeycloak({ commit }, credentials) {
      async function decrypt(encryptedData, secretKey) {
        const key = new TextEncoder().encode(secretKey);
        const encryptedDataBytes = Uint8Array.from(atob(encryptedData), (c) =>
          c.charCodeAt(0)
        );
        const iv = encryptedDataBytes.slice(0, 12);
        const encryptedBytes = encryptedDataBytes.slice(12);
        const cryptoKey = await crypto.subtle.importKey(
          "raw",
          key,
          { name: "AES-GCM" },
          false,
          ["decrypt"]
        );
        const decryptedArrayBuffer = await crypto.subtle.decrypt(
          {
            name: "AES-GCM",
            iv,
          },
          cryptoKey,
          encryptedBytes
        );
        const decryptedData = new TextDecoder().decode(decryptedArrayBuffer);
        return decryptedData;
      }
      commit("setLoading", 1, { root: true });
      try {
        const response = await axios.post("login/auth/prckc", {
          company: credentials,
        });
        commit("setLoading", -1, { root: true });
        commit("setActiveKeycloak", response.data[0].value);

        if (response.data[0].value === "SI") {
          const key = process.env.VUE_APP_KC;
          let urlKeycloak;
          let realm;
          let clientIdKeycloak;
          for (const pr of response.data) {
            switch (pr.key) {
              case "FE_LOGIN_URL_KEYCLOAK":
                urlKeycloak = pr.value;
                break;
              case "REALM":
                realm = pr.value;
                break;
              case "FE_CLIENT_ID_KEYCLOAK":
                clientIdKeycloak = pr.value;
                break;
              default:
                break;
            }
          }
          const decryptUrlKeycloak = await decrypt(urlKeycloak, key);
          const realmDecrypted = await decrypt(realm, key);
          const clientIdKeycloakDecrypted = await decrypt(
            clientIdKeycloak,
            key
          );

          commit("setRealm", realmDecrypted);
          commit("setUrlKeycloak", decryptUrlKeycloak);
          commit("setClientIdKeycloak", clientIdKeycloakDecrypted);
        }
      } catch (e) {
        return Promise.reject(e);
      }
      return Promise.response;
    },
    logoutWithoutRequest({ commit }) {
      commit("setStatus", false);
      commit("setUser", {});
      commit("setToken", "");
      commit("setPermissions", []);
      commit("setLoading", -1, { root: true });
      commit("setPrimerLogin", null);
      const a = "adal";
      const kc = "kc";
      const keys = Object.keys(localStorage);

      for (const i in keys) {
        const key = keys[i];
        if (key.includes(a)) {
          window.localStorage.removeItem(key);
        }
        if (key.includes("activeAzure")) {
          window.localStorage.removeItem(key);
        }
        if (key.includes(kc)) {
          window.localStorage.removeItem(key);
        }
      }
      return Promise.resolve();
    },
  },
};
